module.exports = __webpack_public_path__ + "img/img6.5a2ca107.jpg";